import { apiLoja } from '@/services/api';
import { SALES_SET, SALES_PAGINATION_SET, SALES_STATISTIC_SET, SALES_LOADING_PAGINATION, SALES_LOADED_PAGINATION, SALES_STATUS_SET, SALES_LOADING, SALES_LOADED, SALES_CLEAR, SALES_FILTER_SET } from '../actionTypes';
import qs from 'qs';

export const setSales = (sales) => ({
  type: SALES_SET,
  payload: sales,
});

export const setSalesPagination = (salesPagination) => {
  return {
    type: SALES_PAGINATION_SET,
    payload: salesPagination
  };
};

export const setSalesStatistic = (salesStatistic) => {
  return {
    type: SALES_STATISTIC_SET,
    payload: salesStatistic
  };
};

export const loadingSalesPagination = () => ({
  type: SALES_LOADING_PAGINATION
});

export const loadedSalesPagination = () => ({
  type: SALES_LOADED_PAGINATION
});

export const setSalesStatus = (salesStatus) => ({
  type: SALES_STATUS_SET,
  payload: salesStatus,
});

export const loadingSales = () => ({
  type: SALES_LOADING,
});

export const loadedSales = () => ({
  type: SALES_LOADED,
});

export const clearSales = () => ({
  type: SALES_CLEAR,
});

export const setFilterSales = (filters) => ({
  type: SALES_FILTER_SET,
  payload: filters,
});

export const fetchSales = (idPole, initialDate, endDate) => {
  return (dispatch) => {
    dispatch(loadingSales());

    apiLoja
      .post(`/Vendas/GetAll`, {
        IdPolo: idPole,
        DataInicial: initialDate,
        DataFinal: endDate,
      })
      .then((data) => {
        dispatch(setSales(data.data));
        dispatch(loadedSales());
      })
      .catch(() => {
        dispatch(loadedSales());
      });
  };
};

export const fetchAllSalesStatus = () => {
  return (dispatch) => {
    dispatch(loadingSales());

    apiLoja
      .get(`/Vendas/GetAllVendaStatus`)
      .then((data) => {
        dispatch(setSalesStatus(data.data));
        dispatch(loadedSales());
      })
      .catch(() => {
        dispatch(loadedSales());
      });
  };
};

export const fetchAllSalesFranchisor = (idPole, idSaleStatus, idSale, initialDate, endDate, exportarPlanilha, customerName, CPFCNPJ, saleType, shipmentType, idPaymentStatus) => {
  return (dispatch, getState) => {
    if (!exportarPlanilha) {
      dispatch(loadingSales());
    }

    const state = getState();
    const user = state.user.user;
    const idFranqueadora = user.IdFranqueadora;

    const data = {
      IdFranqueadora: idFranqueadora,
      IdPolo: idPole,
      IdVenda: idSale,
      IdVendaStatus: idSaleStatus,
      IdPagamentoStatus: idPaymentStatus,
      DataInicial: initialDate,
      DataFinal: endDate,
      ExportarPlanilha: exportarPlanilha,
      NomeCliente: customerName,
      CPFCNPJ: CPFCNPJ,
      FiltroExpedicao: saleType,
      TipoExpedicao: shipmentType
    };

    return apiLoja
      .post("/Vendas/GetAllMinhasVendasByFranqueadora", data)
      .then((data) => {
        dispatch(setSales(data.data));
        dispatch(loadedSales());
        return data.data;
      })
      .catch(() => {
        dispatch(loadedSales());
      });
  };
};

export const fetchAllSalesFranchisorPagination = (page, qtItems, idPole, idSaleStatus, idSale, initialDate, endDate, customerName, CPFCNPJ, saleType, shipmentType, idPaymentStatus) => {
  return (dispatch, getState) => {
    dispatch(loadingSalesPagination());

    const state = getState();
    const user = state.user.user;
    const idFranqueadora = user.IdFranqueadora;

    const data = {
      PaginaAtual: page,
      QtdItem: qtItems,
      IdFranqueadora: idFranqueadora,
      IdPolo: idPole,
      IdVenda: idSale,
      IdVendaStatus: idSaleStatus,
      IdPagamentoStatus: idPaymentStatus,
      DataInicial: initialDate,
      DataFinal: endDate,
      NomeCliente: customerName,
      CPFCNPJ: CPFCNPJ,
      FiltroExpedicao: saleType,
      TipoExpedicao: shipmentType
    };

    return apiLoja
      .post("/Vendas/GetAllMinhasVendasPaginacao", data)
      .then((response) => {
        dispatch(setSalesPagination(response.data));
        dispatch(loadedSalesPagination());
        return response.data;
      })
      .catch((error) => {
        dispatch(loadedSalesPagination());
        return null;
      });
  };
};

export const fetchAllSalesStatisticFranchisor = (idPole, idSaleStatus, idSale, initialDate, endDate, customerName, CPFCNPJ, saleType, shipmentType, idPaymentStatus) => {
  return (dispatch, getState) => {

    const state = getState();
    const user = state.user.user;
    const idFranqueadora = user.IdFranqueadora;

    const data = {
      IdFranqueadora: idFranqueadora,
      IdPolo: idPole,
      IdVenda: idSale,
      IdVendaStatus: idSaleStatus,
      IdPagamentoStatus: idPaymentStatus,
      DataInicial: initialDate,
      DataFinal: endDate,
      NomeCliente: customerName,
      CPFCNPJ: CPFCNPJ,
      FiltroExpedicao: saleType,
      TipoExpedicao: shipmentType
    };

    return apiLoja
      .post("/Vendas/GetAllMinhasVendasEstatisticasByFranqueadora", data)
      .then((data) => {
        dispatch(setSalesStatistic(data.data));
        dispatch(loadedSales());
        return data.data;
      })
      .catch(() => {
        dispatch(loadedSales());
      });
  };
};
